/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for full screen icon.
 *
 * @author Hari Gangadharan
 */
const FullScreen = props => (
  <SvgIcon {...props}>
    <path
      d="M1 2.5L1 10 4 10 4 4 10 4 10 1 2.5 1C1.671 1 1 1.672 1 2.5M21.5 1L14 1 14 4 20 4 20 10 23 10 23
      2.5C23 1.672 22.329 1 21.5 1M4 14L1 14 1 21.5C1 22.328 1.671 23 2.5 23L10 23 10 20 4 20 4 14zM20 20L14
      20 14 23 21.5 23C22.329 23 23 22.328 23 21.5L23 14 20 14 20 20z"
    />
  </SvgIcon>
);

export default FullScreen;



// WEBPACK FOOTER //
// ./src/js/icons/FullScreen.jsx